<template>
  <div v-if="rank.number && lvl" class="user-lvl">
    <i @click="showTooltip = true" :class="`rank-${rank.number}`" />
    <div @click="showTooltip = true" class="lvl">{{ lvl }}</div>
    <div v-show="showTooltip" class="tooltip">
      <i @click="showTooltip = false" class="close" />
      <div class="exp-info">
        <div class="ph">
          <b>Класс</b> {{ rank.name }}
        </div>
        <div class="ph">
          <b>Уровень</b> {{ lvl }}
        </div>
        <div class="ph">
          <div :title="`${exp} / ${(lvl * 2400 + 2400)}`" class="progress">
            <i :style="`width:${(exp / (lvl * 2400 + 2400)) * 100}%`" class="now"></i>
            <b>EXP {{ exp }}</b>
          </div>
        </div>
      </div>
      <div class="ph">
        <nuxt-link to="/expoints">
          Про опыт и уровни <b style="color:red;">?</b>
        </nuxt-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: { exp: { type: Number, require: true, default: 0 } },
  computed: {
    lvl() {
      return Math.floor(this.exp / 2400)
    },
    rank() {
      const rank = Math.floor(this.lvl / 10) < 1 ? 1 : Math.floor(this.lvl / 10)
      return {
        name: rank === 1
          ? 'D'
          : rank === 2
            ? 'C'
            : rank === 3
              ? 'B'
              : rank === 4
                ? 'A'
                : rank === 5
                  ? 'S'
                  : rank >= 6
                    ? 'S+'
                    : '',
        number: rank >= 6 ? 6 : rank
      }
    }
  },
  data() {
    return {
      showTooltip: false
    }
  }
}
</script>
